/*!
 * struct.js - struct object for bcoin
 * Copyright (c) 2018, Christopher Jeffrey (MIT License).
 * https://github.com/bcoin-org/bcoin
 */
'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var enforce = require('./enforce');

var BufferReader = require('./reader');

var BufferWriter = require('./writer');

var StaticWriter = require('./staticwriter');

var _require = require('./custom'),
    custom = _require.custom;
/**
 * Struct
 */


var Struct = /*#__PURE__*/function () {
  function Struct() {
    _classCallCheck(this, Struct);
  }

  _createClass(Struct, [{
    key: "inject",
    value: function inject(obj) {
      enforce(obj instanceof this.constructor, 'obj', 'struct');
      return this.decode(obj.encode());
    }
  }, {
    key: "clone",
    value: function clone() {
      var copy = new this.constructor();
      return copy.inject(this);
    }
    /*
     * Bindable
     */

  }, {
    key: "getSize",
    value: function getSize(extra) {
      return -1;
    }
  }, {
    key: "write",
    value: function write(bw, extra) {
      return bw;
    }
  }, {
    key: "read",
    value: function read(br, extra) {
      return this;
    }
  }, {
    key: "toString",
    value: function toString() {
      return Object.prototype.toString.call(this);
    }
  }, {
    key: "fromString",
    value: function fromString(str, extra) {
      return this;
    }
  }, {
    key: "getJSON",
    value: function getJSON() {
      return this;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json, extra) {
      return this;
    }
  }, {
    key: "fromOptions",
    value: function fromOptions(options, extra) {
      return this;
    }
  }, {
    key: "from",
    value: function from(options, extra) {
      return this.fromOptions(options, extra);
    }
  }, {
    key: "format",
    value: function format() {
      return this.getJSON();
    }
    /*
     * API
     */

  }, {
    key: "encode",
    value: function encode(extra) {
      var size = this.getSize(extra);
      var bw = size === -1 ? new BufferWriter() : new StaticWriter(size);
      this.write(bw, extra);
      return bw.render();
    }
  }, {
    key: "decode",
    value: function decode(data, extra) {
      var br = new BufferReader(data);
      this.read(br, extra);
      return this;
    }
  }, {
    key: "toHex",
    value: function toHex(extra) {
      return this.encode(extra).toString('hex');
    }
  }, {
    key: "fromHex",
    value: function fromHex(str, extra) {
      enforce(typeof str === 'string', 'str', 'string');
      var size = str.length >>> 1;
      var data = Buffer.from(str, 'hex');
      if (data.length !== size) throw new Error('Invalid hex string.');
      return this.decode(data, extra);
    }
  }, {
    key: "toBase64",
    value: function toBase64(extra) {
      return this.encode(extra).toString('base64');
    }
  }, {
    key: "fromBase64",
    value: function fromBase64(str, extra) {
      enforce(typeof str === 'string', 'str', 'string');
      var data = Buffer.from(str, 'base64');
      if (str.length > size64(data.length)) throw new Error('Invalid base64 string.');
      return this.decode(data, extra);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.getJSON();
    }
  }, {
    key: custom,
    value: function value() {
      return this.format();
    }
    /*
     * Static API
     */

  }, {
    key: "toWriter",

    /*
     * Aliases
     */
    value: function toWriter(bw, extra) {
      return this.write(bw, extra);
    }
  }, {
    key: "fromReader",
    value: function fromReader(br, extra) {
      return this.read(br, extra);
    }
  }, {
    key: "toRaw",
    value: function toRaw(extra) {
      return this.encode(extra);
    }
  }, {
    key: "fromRaw",
    value: function fromRaw(data, extra) {
      return this.decode(data, extra);
    }
    /*
     * Static Aliases
     */

  }], [{
    key: "read",
    value: function read(br, extra) {
      return new this().read(br, extra);
    }
  }, {
    key: "decode",
    value: function decode(data, extra) {
      return new this().decode(data, extra);
    }
  }, {
    key: "fromHex",
    value: function fromHex(str, extra) {
      return new this().fromHex(str, extra);
    }
  }, {
    key: "fromBase64",
    value: function fromBase64(str, extra) {
      return new this().fromBase64(str, extra);
    }
  }, {
    key: "fromString",
    value: function fromString(str, extra) {
      return new this().fromString(str, extra);
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json, extra) {
      return new this().fromJSON(json, extra);
    }
  }, {
    key: "fromOptions",
    value: function fromOptions(options, extra) {
      return new this().fromOptions(options, extra);
    }
  }, {
    key: "from",
    value: function from(options, extra) {
      return new this().from(options, extra);
    }
  }, {
    key: "fromReader",
    value: function fromReader(br, extra) {
      return this.read(br, extra);
    }
  }, {
    key: "fromRaw",
    value: function fromRaw(data, extra) {
      return this.decode(data, extra);
    }
  }]);

  return Struct;
}();
/*
 * Helpers
 */


function size64(size) {
  var expect = 4 * size / 3 + 3 & ~3;
  return expect >>> 0;
}
/*
 * Expose
 */


module.exports = Struct;